<ng-container *transloco="let t;">
  <app-list-view [title]="t('common.labels.texttemplates')" [messages]="messages" [loading]="loading">

    <div buttons>
      <button withRight="admin.texttemplate.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
    </div>

    <div table>
      <p-table
        [value]="texttemplates"
        [paginator]="true"
        [rows]="20"
        stateStorage="local"
        stateKey="texttemplate-list"
        [rowsPerPageOptions]="rowsPerPage"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="t('common.labels.current_page_report')"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="identifier">{{ t('common.labels.identifier') }}
              <p-sortIcon field="identifier"></p-sortIcon>
            </th>
            <th pSortableColumn="type">{{ t('common.labels.type') }}
              <p-sortIcon field="type"></p-sortIcon>
            </th>
            <th>{{ t('common.labels.description') }}</th>
            <th>{{ t('common.labels.languages') }}</th>
          </tr>
          <tr class="filter">
            <th>
              <p-columnFilter type="text" field="identifier" [matchMode]="'contains'"></p-columnFilter>
            </th>
            <th>

              <p-columnFilter field="type" matchMode="equals" [showMenu]="true">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-dropdown [ngModel]="value" [options]="types" (onChange)="filter($event.value)" [placeholder]="t('common.labels.all')" [showClear]="true"></p-dropdown>
                </ng-template>
              </p-columnFilter>

            </th>
            <th>
              <p-columnFilter type="text" field="description" [matchMode]="'contains'"></p-columnFilter>
            </th>
            <th>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-texttemplate>
          <tr (click)="onOpen(texttemplate)" (keyup.enter)="onOpen(texttemplate)" hoverOnRight="admin.texttemplate.show" tabindex="0">
            <td><span role="link">{{texttemplate.identifier}}</span></td>
            <td><span role="link">{{ t('common.labels.' + texttemplate.type) }}</span></td>
            <td><span role="link">{{texttemplate.description}}</span></td>
            <td><span role="link">{{texttemplate.language_list}}</span></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="4">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>

      <div class="p-mt-4">
        <app-form-control [cid]="'show_inactive'" [control]="form.get('show_inactive')" [type]="'checkbox'" [label]="t('texttemplate_list.show_inactive')"></app-form-control>
      </div>

    </div>

  </app-list-view>
</ng-container>
